import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';

export const findGuaranteesOptionByValue = <TOption extends TAutocompleteOption>(
  options: TOption[],
  value?: string
): TOption | null => options.find((option) => option.value === value) ?? null;
